export enum RelationshipTypeEnum {
  OneToOne = 'one_to_one',
  OneToMany = 'one_to_many',
  ManyToOne = 'many_to_one',
  ManyToMany = 'many_to_many'
}
